import { debounce, put, call } from 'redux-saga/effects';

import { Creators, Types } from 'src/store/redux/labs/actions';
import labsApi from 'src/services/api/labs';

export function* list(action: any) {
  try {
    const response = yield call(labsApi.list, action.filters);
    yield put(Creators.labsListRequestSuccess(response.data));
  } catch (e) {
    let error = e.response;
    yield put(Creators.labsListRequestError(error));
  }
}

export function* watchList() {
  yield debounce(6e2, Types.LABS_LIST_REQUEST, list);
}

export default watchList;
